module.exports = __webpack_public_path__ + "assets/img/login-player.9420c0ef.svg";